import config from 'Cloud/config';

const { PH_RegisterBackURL } = config.get('PHLinks') || {};

export const getSuccessPage = (location: any) => {
    if (
        /^((\/subscriptions)|(\/promocodes)|(\/discount)|(\/promo\/quota)|(\/promo\/quota\/partner)|(\/public)|(\/promo\/present))\/?$/.test(
            location.pathname
        )
    ) {
        return location.href;
    }

    if (/^\/integration/.test(location.pathname)) {
        return `${location.protocol}//${location.hostname}/integration/${location.search}`;
    }

    return `${location.protocol}//${location.hostname}/home/`;
};

export const reloadPage = () => {
    // @ts-ignore
    RADAR.beaconImmediate('auth_change').after(function () {
        const href = getSuccessPage(window.location);

        if (href === window.location.href) {
            window.location.reload();
        } else {
            window.location.href = href;
        }
    });
};

const registerLink = `https://r.mail.ru/cls22587493/r.mail.ru/clb1126011/e.mail.ru/signup?from=navi&lang=ru_RU&back=${PH_RegisterBackURL}`;

export const goToRegisterPage = () => {
    window.open(registerLink, '_blank');
};
